/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDUturnRightUpIcon16Light } from './ArrowDUturnRightUpIcon16Light';
import { ArrowDUturnRightUpIcon16Regular } from './ArrowDUturnRightUpIcon16Regular';
import { ArrowDUturnRightUpIcon16Solid } from './ArrowDUturnRightUpIcon16Solid';
import { ArrowDUturnRightUpIcon20Light } from './ArrowDUturnRightUpIcon20Light';
import { ArrowDUturnRightUpIcon20Regular } from './ArrowDUturnRightUpIcon20Regular';
import { ArrowDUturnRightUpIcon20Solid } from './ArrowDUturnRightUpIcon20Solid';
import { ArrowDUturnRightUpIcon24Regular } from './ArrowDUturnRightUpIcon24Regular';
import { ArrowDUturnRightUpIcon24Solid } from './ArrowDUturnRightUpIcon24Solid';
import { ArrowDUturnRightUpIcon32Regular } from './ArrowDUturnRightUpIcon32Regular';
import { ArrowDUturnRightUpIcon64Regular } from './ArrowDUturnRightUpIcon64Regular';
var sizes = {
    16: {
        light: ArrowDUturnRightUpIcon16Light,
        regular: ArrowDUturnRightUpIcon16Regular,
        solid: ArrowDUturnRightUpIcon16Solid,
    },
    20: {
        light: ArrowDUturnRightUpIcon20Light,
        regular: ArrowDUturnRightUpIcon20Regular,
        solid: ArrowDUturnRightUpIcon20Solid,
    },
    24: {
        regular: ArrowDUturnRightUpIcon24Regular,
        solid: ArrowDUturnRightUpIcon24Solid,
    },
    32: {
        regular: ArrowDUturnRightUpIcon32Regular,
    },
    64: {
        regular: ArrowDUturnRightUpIcon64Regular,
    },
};
export var ArrowDUturnRightUpIcon = forwardRef('ArrowDUturnRightUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
